import React, { useState } from 'react'
import FormConfigVisio from '../Forms/FormConfigVisio'
import ApiAGS from '../../../api/apiAgs'

const ConfigVisio = ({ record, refresh }) => {
  const [message, setMessage] = useState('')
  const [isError, setIsError] = useState(false)
  const apiAGS = new ApiAGS()
  if (!record) {
    return null
  }
  const onSubmit = async (data, reset) => {
    const res = await apiAGS.update(data)
    if (res.status === 200) {
      reset(data)
      setMessage('Votre configuration visio a été modifiée avec succès')
      setIsError(false)
    } else {
      setMessage("Une erreur s'est produite lors de la modification de la configuration de la visio. Veuillez réessayer.")
      setIsError(true)
    }
    // hide the message after 3 seconds
    setTimeout(() => {
      setMessage(null)
    }, 3000)
  }
  const onArchive = async (paylod) => {
    const res = await apiAGS.update(paylod)
    if (res.status === 200) {
      refresh()
      setMessage('Votre AG a été archivé avec succès.')
      setIsError(false)
    } else {
      setMessage("Une erreur s'est produite lors de l'archivage d'AG. Veuillez réessayer.")
      setIsError(true)
    }
    // hide the message after 3 seconds
    setTimeout(() => {
      setMessage(null)
    }, 3000)
  }

  return (
    <FormConfigVisio record={record} onSubmit={onSubmit} isError={isError} message={message} onArchive={onArchive} />
  )
}

export default ConfigVisio
